import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import styles from "./LiveHandoff.module.scss";

// The fade's length, as the stylesheet has it; the fallback for a
// transition that never reports its end (a hidden tab, a node gone from
// layout mid-fade) so the opening never lingers under the board.
const FADE_MS = 900;
const FADE_FALLBACK_MS = FADE_MS + 300;

/**
 * The opening over the planned board (TT-1133): the two share the stage,
 * and when the board is up (`up`) the opening fades out over it and is
 * unmounted once its fade ends. The scene's opening is the classic canvas
 * on paper, the board's its lettered sketch; this owns the handoff for
 * both (TT-1215). A closed meeting with no board keeps its opening: what
 * was lettered is all there is (TT-1147).
 *
 * `children` is the planned board (or nothing yet); `opening` the opening
 * canvas (or null once there is nothing to letter).
 */
export default function LiveHandoff({ up, opening, children }) {
  const [gone, setGone] = useState(false);
  useEffect(() => {
    if (!up) return undefined;
    const id = setTimeout(() => setGone(true), FADE_FALLBACK_MS);
    return () => clearTimeout(id);
  }, [up]);
  const showOpening = opening != null && !gone;
  return (
    <div className={styles.handoff}>
      {children}
      {showOpening && (
        <div
          className={up ? `${styles.opening} ${styles.openingOut}` : styles.opening}
          onTransitionEnd={up ? () => setGone(true) : undefined}
        >
          {opening}
        </div>
      )}
    </div>
  );
}

LiveHandoff.propTypes = {
  // The planned board is up: fade the opening out and let it go.
  up: PropTypes.bool,
  opening: PropTypes.node,
  children: PropTypes.node,
};
